import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc1083b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center mt-10 mb-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提示")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("小时")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("下载附件")

import { ref, Ref, onBeforeMount } from 'vue'
import dayjs from 'dayjs';
import eptBtn from '@/components/ExportButton.vue'
import tbMix from '@/global_mixin/tableMixin'
import Api from '@/http/modules/index'
import store from '@/store/index'
import { getNumber, formatTime } from '@/utils';
import { ElMessage, ElMessageBox } from 'element-plus/lib/components';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let { 
  'POST/checkin_approvals/list': fetchList,
  // 请假修改
  'PATCH/checkin_approvals': checkin_approvalsApi,
  // 导出请假审批数据
  'POST/checkin_approvals/export': checkin_approvalsExportApi,
  // 下载导入请假数据模板
  'GET/checkin_approvals/download': checkin_approvalsDownloadApi,
  // 导入请假数据
  'POST/checkin_approvals/import': checkin_approvalsImportAPI,
  // 对接企业微信获取上传附件并打包zip
  'GET/checkin_approvals/enclosure': EnclosureApi,
  // 员工列表(不分页,下拉框)
  'GET/users/list': userListApi,
  // 获取-请假类型(下拉)
  'GET/checkin_approvals/type': checkin_approvalsTypeApi,
  // 所有办公所在地
  'GET/house_leases': fullOfficeApi,
} = Api


let fullUserList: any = ref([])
let leavesType: any= ref([])

const searchConfig = ref([
  {
    type: "TIME",
    label: "日期",
    value: [dayjs().startOf('month').format('YYYY-MM-DD'), dayjs().endOf('month').format('YYYY-MM-DD'),],
    upKey: 'dates',
    props: {
      type: 'daterange',
      'value-format': 'YYYY-MM-DD'
    },
    upProps: {
      includeKey: 'dateRange'
    }
  },
  {
    label: "姓名",
    value: '',
    upKey: 'key',
    props: { clearable : true }
  },
  {
    type: "SELECT",
    label: "类型",
    value: "",
    upKey: "type",
    options: leavesType,
    placeholder: "请选择类型",
    props: { clearable: true },
    seleProps: {
        label: "name",
        valueName: "id",
    },
  },
  {
    type: "SELECT",
    label: "加班类型",
    value: "",
    upKey: "selector",
    options: [
      { name: '调休', id: '调休' },
      { name: '加班换薪', id: '加班换薪' },
      { name: '加班津贴（固定费率）', id: '加班津贴（固定费率）' },
      { name: '年假/调休假换薪', id: '年假/调休假换薪' },
      { name: '调休假换薪', id: '调休假换薪' },
      { name: '年假换薪', id: '年假换薪' },
    ],
    placeholder: "请选择加班类型",
    props: { clearable: true },
    seleProps: {
      label: "name",
      valueName: "id",
    },
  },
  {
    type: "SELECT",
    label: "加班校对",
    value: "",
    upKey: "colorMark",
    options: [
      { name: '未打卡', id: '0' },
      { name: '跨一天', id: '1' },
      { name: '跨一天以上', id: '2' },
      { name: '已修正', id: '3' },
    ],
    placeholder: "请选择加班校对",
    props: { clearable: true },
    seleProps: {
      label: "name",
      valueName: "id",
    },
  },
  {
    type: "SELECT",
    label: "无效审批人",
    value: "",
    upKey: "invalid",
    options: [
      { name: '无效审批人', id: '无效审批人' },
    ],
    placeholder: "请选择无效审批人",
    props: { clearable: true },
    seleProps: {
      label: "name",
      valueName: "id",
    },
  },
  {
    type: 'SELECT',
    label: '团队',
    value: '',
    upKey: 'orgId',
    options: store.getters.sysOrganizations,
    props: { placeholder: '请选择团队', clearable: true },
    seleProps: {label: 'name',valueName: 'id',},
  },
  {
    type: 'SELECT',
    selectType: 'GROUP',
    label: '公司',
    value: '',
    upKey: 'companyIds',
    options: store.getters.sysCompany,
    props: { clearable: true, multiple: true, 'collapse-tags': true, style: 'width: 350px' },
    seleProps: {label: 'name', valueName: 'id'}
  },
  {
    type: "SELECT",
    label: "计算方式",
    value: "",
    upKey: "state",
    options: [
      { name: '系统自动计算', id: 1 },
      { name: '用户修改', id: 2 },
    ],
    props: { clearable: true, placeholder: "请选择计算方式", },
    seleProps: { label: "name", valueName: "id", },
  },
  {
    type: 'SELECT',
    label: '办公所在地',
    value: '',
    upKey: 'leaseId',
    options: [],
    placeholder: '请选择办公所在地',
    funcParam: {},
    selectFunc: fullOfficeApi,
    // rule: defRules,
    props: {
    clearable: true
    },
    seleProps: {
      label: 'alias',
      valueName: 'id',
    }
  },
])




onBeforeMount(() => {
  userListApi().then((_userList: object[]) => {
    fullUserList.value = _userList.map((_user: any) => {
      _user.label = `${_user.realName}(${_user.alias})`
      return _user
    })
  })
  checkin_approvalsTypeApi().then((rep: any) => {
    leavesType.value = Object.values(rep).map((type: any) => {
      return {label: type, id: type}
    })
  })

})

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height 
} = new tbMix(fetchList)

const modifyFg = ref(false)
const modifyConfig = ref([
  {
    type: "SELECT",
    label: "类型",
    value: "",
    upKey: "spName",
    options: leavesType,
    props: { clearable: true, placeholder: "请选择类型", },
    seleProps: {
      label: "name",
      valueName: "id",
    },
  },
  {
    label: '小时',
    value: '0',
    upKey: 'time',
    props: {
      type: 'number'
    }
  },
  {
    type: 'NUMBER',
    label: '已抵扣(小时)',
    value: 0,
    upKey: 'convertTime',
    rule: [
      { required: true, message: '请输入已抵扣(小时)', trigger: 'change' },
    ],
    props: {
    }
  },
  {
    type: 'SELECT',
    label: '领导',
    value: '',
    upKey: 'leaderId',
    options: fullUserList,
    props: { placeholder: '请选择领导', clearable: true },
    rule: [
      { required: true, message: '领导不能为空', trigger: 'change' },
    ],
    seleProps: {
      label: 'label',
      valueName: 'userId',
    }
  },
  {
    type: "TIME",
    label: "开始时间",
    value: '',
    upKey: 'newBegin',
    props: { clearable: true, type: 'datetime', 'value-format': "YYYY-MM-DDTHH:mm:ss" }
  },
  {
    type: "TIME",
    label: "结束时间",
    value: '',
    upKey: 'newEnd',
    props: { clearable: true, type: 'datetime', 'value-format': "YYYY-MM-DDTHH:mm:ss" }
  },
  {
    type: "SELECT",
    label: "加班类型",
    value: "",
    upKey: "selector",
    options: [
      { name: '调休', id: '调休' },
      { name: '加班换薪', id: '加班换薪' },
      { name: '加班津贴（固定费率）', id: '加班津贴（固定费率）' },
      { name: '年假/调休假换薪', id: '年假/调休假换薪' },
      { name: '调休假换薪', id: '调休假换薪' },
      { name: '年假换薪', id: '年假换薪' },
    ],
    props: { clearable: true, placeholder: "请选择加班类型" },
    seleProps: {
      label: "name",
      valueName: "id",
    },
  },
  {
    label: '备注',
    value: '',
    upKey: 'note',
    props: {
      type: 'textarea'
    }
  },
])
// 修改
const modifyHandle = (row: any) => {
  MI_modifyForm(row, modifyConfig, modifyFg, async (params: any) => {
    console.log(params);
    await checkin_approvalsApi({...params, id: row.id})
    fetchData(MI_params)
    ElMessage.success('修改成功')
    modifyFg.value = false
    
  })
}

const leavesSummaries = (param: any) => {
  const { columns, data } = param
  const sums: string[] = []
  columns.forEach((column: any, index: any) => {
    if (index === 0) {
      sums[0] = '合计'
      return
    }
    const values = data.map((item: any) => Number(item[column.property]))
    if (index === 4) {
      sums[4] = getNumber(values.reduce((prev: any, curr: any) => {
        const value = Number(curr)
        if (!Number.isNaN(value)) {
          return prev + curr
        } else {
          return prev
        }
      }, 0))
    } else {
      sums[index] = ''
    }
  })

  return sums
}

const tableRowClassName = ({ row, rowIndex,}: { row: any, rowIndex: number }) => {
  
  switch (row.colorMark) {
    case '0':
      // 淡红色
      return 'lightRed'
    case '1':
      // 淡黄色
      return 'lightYellow'
    case '2':
      // 橘黄色
      return 'lightOrange'
    case '3':
      // 淡蓝色
      return 'lightBlue'
  
    default:
      return ''
  }
  return ''
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "点此搜索请假" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, { onSearchFn: _unref(fetchData) }), null, 16, ["onSearchFn"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_tooltip, {
        effect: "dark",
        content: "企业微信审批，每个整点获取一次,无论事假/调休假/年假，实际事假小时=(事假/调休假年假)小时-已抵扣(小时)，有差值代表无假期抵扣，默认差值为实际事假小时",
        placement: "bottom-start"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { type: "info" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _withDirectives((_openBlock(), _createBlock(_component_TheUpBtn, {
        class: "ml-10",
        upText: '导入请假数据',
        upFetch: _unref(checkin_approvalsImportAPI),
        upParams: {},
        showBtn: true
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(eptBtn, {
            type: "primary",
            exportFn: _unref(checkin_approvalsDownloadApi),
            exportText: '下载请假数据模板'
          }, null, 8, ["exportFn"]), [
            [_directive_permission, void 0, "checkin"]
          ])
        ]),
        _: 1
      }, 8, ["upFetch"])), [
        [_directive_permission, void 0, "checkin"]
      ]),
      _withDirectives(_createVNode(eptBtn, {
        exportParam: _unref(MI_params),
        exportFn: _unref(checkin_approvalsExportApi),
        exportText: '导出请假审批'
      }, null, 8, ["exportParam", "exportFn"]), [
        [_directive_permission, void 0, "checkin"]
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      "show-summary": "",
      "summary-method": leavesSummaries,
      "row-class-name": tableRowClassName,
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) - 60 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "realName",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(`${ row.realName }(${row.alias})`), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "开始时间",
          prop: "newBegin",
          formatter: _unref(formatTime),
          width: "150",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "结束时间",
          prop: "newEnd",
          formatter: _unref(formatTime),
          width: "150",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "类别",
          prop: "spName",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.spName === '加班' ? row.selector : row.spName), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "小时",
          prop: "time"
        }, {
          header: _withCtx(() => [
            _createVNode(_component_el_tooltip, {
              effect: "dark",
              content: "企业微信审批，每个整点获取一次",
              placement: "top-start"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, [
                  _hoisted_3,
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_QuestionFilled)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "已抵扣(小时)",
          prop: "convertTime"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.convertTime == '0' ? '' : row.convertTime), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "计算方式",
          prop: "state"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.state == '1' ? '系统计算 ' : '手动计算'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "审批人",
          prop: "approvalBy",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "领导",
          prop: "leaderName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "note",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "修改人",
          prop: "updatedBy",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "修改时间",
          prop: "updatedAt",
          formatter: _unref(formatTime),
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "130",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (modifyHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["onClick"])), [
                  [_directive_permission, void 0, "checkin"]
                ]),
                (row.enclosure)
                  ? _withDirectives((_openBlock(), _createBlock(eptBtn, {
                      key: 0,
                      exportParam: {name: row.alias, spNo: row.spNo, },
                      exportFn: _unref(EnclosureApi),
                      exportText: ''
                    }, {
                      default: _withCtx(({ exportFn }) => [
                        _createVNode(_component_el_link, { onClick: exportFn }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["exportParam", "exportFn"])), [
                      [_directive_permission, void 0, "checkin"]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      "page-size": _unref(size),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50, 100, ],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "page-size", "currentPage", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "修改",
      modelValue: modifyFg.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modifyFg).value = $event))
    }, {
      default: _withCtx(() => [
        (modifyFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: modifyConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})